<div
  class="container"
  data-cy="ops-settings-system-color-color-list-item"
  [class.edit-disabled]="!data.isEditable || !canEditVessel"
  [class.readonly]="readonly"
  [class.selected]="selected">
  <div class="color-input-wrapper" [class.changing]="isColorPickerOpen">
    <input
      [disabled]="!canEditVessel"
      readonly
      class="color-input"
      [(colorPicker)]="value"
      (colorPickerChange)="colorChange()"
      [style.background]="value"
      style.width="40px"
      style.height="40px"
      cpOutputFormat="rgba"
      cpAlphaChannel="disabled"
      (colorPickerOpen)="colorPickerClick(true)"
      (colorPickerClose)="colorPickerClick(false)"
      data-cy="ops-settings-system-color-color-picker" />
  </div>
  <div class="color-content-container" [class.error]="rgbErrorMessage">
    <div class="color-container">
      <h6 class="title">{{ data.name | translate }}</h6>
      <input
        [disabled]="!canEditVessel"
        class="color-text text"
        data-cy="ops-settings-system-color-rgb"
        *ngIf="data.color"
        [(ngModel)]="rgb"
        (ngModelChange)="rgbChange()"
        (blur)="rbgaSave()"
        (keydown)="validRGBKeyDown($event)"
        (keydown.enter)="rbgaSave()" />
      <div class="not-color" data-cy="ops-settings-system-color-no-color" *ngIf="!data.color">
        {{ 'system-color.input.color-none-selected' | translate }}
      </div>
    </div>
    <div *ngIf="!data.isEditable && !readonly" class="status-wrapper">
      <span class="status">{{ 'system-color.input.cannot-change' | translate }}</span>
    </div>
    <div></div>
    <div class="icon-container" *ngIf="!offOptions">
      <button
        class="icon-button"
        *ngIf="data.color"
        (click)="removeNonCustomColors()"
        [disabled]="!canEditVessel">
        <mat-icon
          class="icon"
          data-cy="ops-settings-system-color-remove-color-icon"
          svgIcon="minus">
          <div class="tooltip">
            <div class="message">
              {{ 'system-color.tooltip.remove-color' | translate }}
            </div>
          </div>
        </mat-icon>
      </button>
      <button
        class="icon-button"
        (click)="editCustomColor()"
        *ngIf="data.type === CUSTOM_TYPE"
        [disabled]="!canEditVessel">
        <mat-icon
          class="icon"
          data-cy="ops-settings-system-color-edit-details-icon"
          svgIcon="edit-pen">
          <div class="tooltip">
            <div class="message">
              {{ 'system-color.tooltip.edit-details' | translate }}
            </div>
          </div>
        </mat-icon>
      </button>
      <button
        class="icon-button"
        (click)="deleteCustomColor()"
        [disabled]="!canEditVessel"
        *ngIf="data.type === CUSTOM_TYPE">
        <mat-icon
          class="icon"
          data-cy="ops-settings-system-color-remove-color-assign-icon"
          svgIcon="delete">
          <div class="tooltip">
            <div class="message">
              {{ 'system-color.tooltip.remove-color-assignment' | translate }}
            </div>
          </div>
        </mat-icon>
      </button>
    </div>
  </div>
</div>

<div class="error-message" *ngIf="rgbErrorMessage">
  {{ rgbErrorMessage | translate }}
</div>
